<template>
  <section class="hero main_hero">
    <div class="hero-head">
      <nav
        class="navbar is-transparent"
        role="navigation"
        aria-label="main navigation">
        <div class="container">
          <div class="navbar-brand">
            <a class="navbar-item">
              <router-link to="/">
                <img src="./assets/logo/logo.jpeg" />
              </router-link>
            </a>
            <a
              role="button"
              class="navbar-burger burger"
              aria-label="menu"
              aria-expanded="false"
              data-target="navbarTopMainDelete">
              <!--<span aria-hidden="true"></span>-->
              <!--<span aria-hidden="true"></span>-->
              <!--<span aria-hidden="true"></span>-->
              
              <router-link to="/">
                <img src="./assets/logo/logo.jpeg" />
              </router-link>
            </a>
          </div>
          <div class="navbar-menu" id="navbarTopMain">
            <div class="navbar-end">
              <a class="navbar-item has-text-weight-semibold">
                <router-link class="nav-item" to="/poissons">
                  <span>Poissons</span>
                </router-link>
              </a>
              <a class="navbar-item has-text-weight-semibold">
                <router-link class="nav-item" to="/aquariums">
                  <span>Aquariums</span>
                </router-link>
              </a>
              <a class="navbar-item has-text-weight-semibold">
                <router-link class="nav-item" to="/aliments">
                  <span>Aliments de poissons</span>
                </router-link>
              </a>
              <div class="navbar-item">
                <!-- <a>
                  <template v-if="$store.state.isAuthenticated">
                    <router-link class="button is-purple" to="/my-account">
                      Mon compte
                    </router-link>
                  </template>

                  <template v-else>
                    <router-link class="button is-purple" to="/log-in">
                      Connexion
                    </router-link>
                  </template>
                </a>-->
                <a>
                  <router-link to="/">
                    <img src="./assets/logo/logo.jpeg" />
                  </router-link>
                </a>
              </div>
            </div>

          </div>
        </div>
      </nav>
      <div class="tabs is-centered">
        <ul>
          <li>
            <router-link to="/poissons">
              <span class="tab-item"></span>
            </router-link>
          </li>
          <li>
            <router-link to="/aquariums">
              <span class="tab-item"></span>
            </router-link>
          </li>
          <li>
            <router-link to="/aliments">
              <span class="tab-item"></span>
            </router-link>
          </li>
        </ul>
      </div>
    </div>
    <div class="hero-body">
      <div class="container has-text-centered">
        <div class="slider-content animated zoomIn pb-6">
          <div>
            <p class="title is-1 main-text"></p>
            <p class="subtitle is-4 main-text"></p>
          </div>
        </div>
      </div>
    </div>
  </section>
  <div class="tabs is-centered">
    <ul>
      <li>
        <router-link class="button is-purple" to="/cart">
          <span class="icon"><i class="fas fa-shopping-cart"></i></span>
          <span>Panier {{ cartTotalLength }}</span>
        </router-link>
      </li>
      <li>
        <a>
          <template v-if="$store.state.isAuthenticated">
            <router-link class="button is-purple" to="/my-account">
              Mon compte
            </router-link>
          </template>

          <template v-else>
            <router-link class="button is-purple" to="/log-in">
              Connexion
            </router-link>
          </template>
        </a>
      </li>
    </ul>
  </div>
  <div class="tabs is-centered">
    <ul>
      <li>
        <router-link to="/poissons">
          <span class="tab-item">Poissons</span>
        </router-link>
      </li>
      <li>
        <router-link to="/aquariums">
          <span class="tab-item">Aquariums</span>
        </router-link>
      </li>
      <li>
        <router-link to="/aliments">
          <span class="tab-item">Aliments de poissons</span>
        </router-link>
      </li>
    </ul>
  </div>
  <div
    class="is-loading-bar has-text-centered"
    v-bind:class="{ 'is-loading': $store.state.isLoading }"
  >
    <div class="lds-dual-ring"></div>
  </div>
  <section class="hero" id="rooms">
    <router-view />
  </section>
  <footer>
    <div class="content has-text-centered">
      <p class="footer-title">Nos spécialités</p>
    </div>
    <div class="tabs is-centered">
      <ul>
        <li>
          <router-link to="/poissons">
            <span class="tab-item">Poissons</span>
          </router-link>
        </li>
        <li>
          <router-link to="/aquariums">
            <span class="tab-item">Aquariums</span>
          </router-link>
        </li>
        <li>
          <router-link to="/aliments">
            <span class="tab-item">Aliments de poissons</span>
          </router-link>
        </li>
      </ul>
    </div>
    <div class="content has-text-centered">
      <p class="footer-title">Vous pouvez nous suivre</p>
    </div>
    <div class="tabs is-centered">
      <ul>
        <li>
          <a class="button button-footer" href="#">
            <i class="fab fa-facebook-square fab-footer"></i>
          </a>
        </li>
        <li>
          <a class="button button-footer" href="#">
            <i class="fab fa-instagram-square fab-footer"></i>
          </a>
        </li>
        <li>
          <a class="button button-footer" href="#">
            <i class="fab fa-twitter-square fab-footer"></i>
          </a>
        </li>
        <li>
          <a class="button button-footer" href="#">
            <i class="fab fa-youtube-square fab-footer"></i>
          </a>
        </li>
      </ul>
    </div>
    <div class="content has-text-centered">
      <p class="footer-end">
        <strong class="footer-end">Aqua-marine</strong>, première entreprise
        aquariophile digitale en Côte d’Ivoire, et première boutique en ligne
        dans le domaine de l’aquariophilie en Côte d’Ivoire.
        <strong class="footer-end">Copyright (c) 2021</strong>
      </p>
    </div>
  </footer>
</template>

<script>

document.addEventListener("DOMContentLoaded", () => {
  // Get all "navbar-burger" elements
  const $navbarBurgers = Array.prototype.slice.call(
    document.querySelectorAll(".navbar-burger"),
    0
  );
  // Check if there are any navbar burgers
  if ($navbarBurgers.length > 0) {
    // Add a click event on each of them
    $navbarBurgers.forEach((el) => {
      el.addEventListener("click", () => {
        // Get the target from the "data-target" attribute
        const target = el.dataset.target;
        const $target = document.getElementById(target);
        // Toggle the "is-active" class on both the "navbar-burger" and the "navbar-menu"
        el.classList.toggle("is-active");
        $target.classList.toggle("is-active");
      });
    });
  }
});
import axios from "axios";
export default {
  data() {
    return {
      cart: {
        items: [],
      },
    };
  },
  beforeCreate() {
    this.$store.commit("initializeStore");
    const token = this.$store.state.token;
    if (token) {
      axios.defaults.headers.common["Authorization"] = "Token " + token;
    } else {
      axios.defaults.headers.common["Authorization"] = "";
    }
  },
  mounted() {
    this.cart = this.$store.state.cart;
  },
  computed: {
    cartTotalLength() {
      let totalLength = 0;
      for (let i = 0; i < this.cart.items.length; i++) {
        totalLength += this.cart.items[i].quantity;
      }
      return totalLength;
    },
  },
};
</script>

<style lang="scss">
@import "../node_modules/bulma";

// Navbar style
#navbarTopMain {
  opacity: 0.9;
}
.main_hero {
  background-image: url("./assets/logo/logo.jpeg");
  background-repeat: no-repeat;
  background-size: 350px 350px;
  background-position: center;
}
.navbar-item img {
  max-height: 3.75rem;
  border-radius: 5rem;
}
.navbar-item {
  text-transform: uppercase;
  font-weight: bold;
  text-decoration: none;
}
.nav-item {
  color: black !important;
}
.fa-search {
  color: #ff00fe !important;
}
.tab-item {
  text-transform: uppercase;
  color: black !important;
}
.navbar-burger {
  padding-top: 10px;
}

.navbar-burger span {
  background-color: #ff00fe;
  display: block;
  height: 1px;
  left: calc(50% - 8px);
  position: absolute;
  transform-origin: center;
  transition-duration: 86ms;
  transition-property: background-color, opacity, transform;
  transition-timing-function: ease-out;
  width: 16px;
}
.title {
  text-transform: uppercase;
  font-size: 20px;
}

.lds-dual-ring {
  display: inline-block;
  width: 80px;
  height: 80px;
}
.lds-dual-ring:after {
  content: " ";
  display: block;
  width: 64px;
  height: 64px;
  margin: 8px;
  border-radius: 50%;
  border: 6px solid #ccc;
  border-color: #ccc transparent #ccc transparent;
  animation: lds-dual-ring 1.2s linear infinite;
}
@keyframes lds-dual-ring {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
}
.is-loading-bar {
  height: 0;
  overflow: hidden;
  -webkit-transition: all 0.3s;
  transition: all 0.3s;
  &.is-loading {
    height: 80px;
  }
}

.hero.is-light .subtitle,
.subtitle {
  color: #ff00fe;
}
.input {
  box-shadow: none;
  -webkit-box-shadow: none;
}
.input:invalid {
  outline: none;
  -webkit-box-shadow: none;
  box-shadow: none;
}
.input:active,
.input:focus {
  -webkit-box-shadow: none;
  box-shadow: none;
}
span {
  text-decoration: none;
}
.button {
  -webkit-transition: all 0.3s ease-out;
  transition: all 0.3s ease-out;
  font-family: Montserrat, sans-serif;
  font-weight: 500;
  text-transform: uppercase;
}
.button.is-purple {
  background-color: #ff00fe;
  color: white !important;
}

.button.is-purple {
  background-color: #ff00fe;
  color: white !important;
}

.button.is-black:hover {
  background-color: white !important;
  color: black !important;
}

.button.is-shadowy {
  box-shadow: 0 5px 30px hsla(224, 8%, 64%, 0.25);
  -webkit-box-shadow: 0 5px 30px hsla(224, 8%, 64%, 0.25);
  -moz-box-shadow: 0 5px 30px hsla(224, 8%, 64%, 0.25);
}
.button.is-shadowy:hover {
  -webkit-box-shadow: 0 16px 43px 2px rgba(0, 0, 0, 0.2);
  box-shadow: 0 16px 43px 2px rgba(0, 0, 0, 0.2);
}
a {
  -webkit-transition: color 0.3s ease-out;
  transition: color 0.3s ease-out;
}

#tasty-fruits-section {
  background-image: url(https://aqua-marine-bucket.s3.us-east-2.amazonaws.com/logo.jpeg);
  background-repeat: no-repeat;
  height: 800px;
  align-items: center;
  justify-content: center;
  display: flex;
  margin-top: 50px;
  margin-bottom: 100px;
}

.footer-end {
  color: #ff00fe;
  font-weight: bold;
  font-size: 15px;
}
.footer-title {
  color: #ff00fe;
  font-weight: bold;
  font-size: 15px;
}
.fab-footer {
  font-size: 40px;
}

.button-footer {
  background-color: white;
  font-size: 20px;
}
</style>